module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/padova.a1c74062c8998f21c468d68ff07cfbe3.jpg";